import { NgModule } from '@angular/core'
import { CommonModule } from '@angular/common'
import { CustomSelectComponent } from './component/custom-select.component'
import { NgSelectModule } from '@ng-select/ng-select'
import { I18nModule } from '@spartacus/core'
import { FormsModule } from '@angular/forms'

@NgModule({
  declarations: [CustomSelectComponent],
  exports: [CustomSelectComponent],
  imports: [CommonModule, NgSelectModule, I18nModule, FormsModule]
})
export class CustomSelectModule {}
